import { USER_PROFILE } from "./actionsTypes"

export function profileUpdate(user) {
  return {
    type: USER_PROFILE,
    payload: user,
  }
}